var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadRandom2Dice = function SvgFadRandom2Dice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.898 100.907a7.97 7.97 0 0 1 8.035-7.935l80.011.623c4.419.034 8.209 3.635 8.466 8.042l.517 8.868 26.68-42.392a7.776 7.776 0 0 1 10.94-2.349l66.996 44.369a8.03 8.03 0 0 1 2.275 11.113l-43.766 66.506c-2.432 3.695-7.447 4.8-11.197 2.47l-51.928-32.265v26.49c0 4.419-3.583 8-7.993 8H32.498a7.949 7.949 0 0 1-7.959-7.998l.36-83.542z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.726 107.6 73.808-.349L111 127l-7.582 12.876c-1.118 1.9-.552 4.46 1.257 5.71l5.954 4.118.035 29.781-74.127-.073.189-71.811zM156.483 79l60.094 39.571-37.612 58.54L118 138.79z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 138,
    cy: 135,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 165,
    cy: 130,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 193,
    cy: 125,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 50,
    cy: 124,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 73,
    cy: 145,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 95,
    cy: 123,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 51,
    cy: 165,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 95,
    cy: 165,
    r: 8
  }))));
};
export { SvgFadRandom2Dice as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-random-2dice.854d58de.svg";